<div class="date-label">
  <div class="date-label-wrapper">
    <div class="text">
      {{ labelValue}}
    </div>
    <div class="trapeze" [ngClass]="direction">
    </div>
  </div>
</div>
